import { render, staticRenderFns } from "./PaginationPageNumbers.vue?vue&type=template&id=7357bb03&scoped=true"
import script from "./PaginationPageNumbers.vue?vue&type=script&lang=ts"
export * from "./PaginationPageNumbers.vue?vue&type=script&lang=ts"
import style0 from "./PaginationPageNumbers.vue?vue&type=style&index=0&id=7357bb03&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7357bb03",
  null
  
)

export default component.exports